
import AjaxPlugin from 'vux/src/plugins/ajax/index.js'
import Cell from 'vux/src/components/cell/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Previewer from 'vux/src/components/previewer/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import XButton from 'vux/src/components/x-button/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'

import wx from 'weixin-js-sdk'
import global_ from './global'

export default {
components: {
XHeader,
XInput,
Group,
XButton,
Cell,
XTextarea,
Previewer
},
directives: {
TransferDom
},
data() {
return {
options: {
getThumbBoundsFn(index) {

let thumbnail = document.querySelectorAll('.previewer-demo-img')[index]

let pageYScroll = window.pageYOffset || document.documentElement.scrollTop


let rect = thumbnail.getBoundingClientRect()

return {x: rect.left, y: rect.top + pageYScroll, w: rect.width}


}
},
role: '',
order: '',
imgList: [],
show: true,
flag: true,
num: 0,
list: [],
index: 0,
newobj: {photo: []},
fdetail_version: '1.1',
isAssis: this.$route.params.isAssis || false,
parhList: []
}
},
methods: {
shows(index) {
if (this.imgList[index].hasOwnProperty('src')) {
this.$refs.previewer.show(index)
} else {
const path = this.parhList[index].origin
this.$vux.loading.show({text: '加载中'})
this.$http.get('api/v1/photos?path=' + path).then(res => {
this.$vux.loading.hide();
this.imgList[index].src = 'data:image/jpeg;base64,' + res.data['value']
this.$refs.previewer.show(index)
})
}
},
confirm() {
let token = localStorage.getItem('token')
let opid = localStorage.getItem('userid')
var that = this
var header = {
headers: {
token: token,
opid: opid
}
}
var data = {
role: this.role,
fdetail: {
version: this.fdetail_version,
content: [{path: this.list}]
}
}
AjaxPlugin.$http.put('api/v1/normalrepairs/' + this.order.seq + '/fdetail', data, header)
.then(res => {
that.$router.push({name: 'normalcomplete', query: {seq: this.order.seq}})
})
.catch(error => {
that.$vux.toast.show({
text: JSON.parse(error.response.data.error_message).zh_string,
type: "cancel",
time: "1000"
})
})
},
upload() {
var app = this

var obj = {
photo: []
}

wx.chooseImage({
count: app.num, // 默认9
sizeType: ['compressed'],
sourceType: ['album', 'camera'],
success: (res) => {
var localIds = res.localIds 
var i = 0;
length = localIds.length;
var upload = () => {
wx.uploadImage({
localId: localIds[i], // 需要上传的图片的本地ID，由chooseImage接口获得
isShowProgressTips: 1, // 默认为1，显示进度提示
success: (res) => {
app.$vux.loading.show()

app.flag = false
if (app.list.length === 0) {
app.newobj.photo.push(res.serverId)
} else {
obj.photo.push(res.serverId)
}
i++
app.num--
if (i < length) {
upload()
} else {
if (app.list.length === 0) {
app.submitImage(app.newobj)
} else {
app.submitImage(obj)
}
}

}
})
}
upload()

}
})
},
submitImage(userInfo) {
var app = this
let token = localStorage.getItem('token')
let opid = localStorage.getItem('userid')
var header = {
headers: {
token: token,
opid: opid
}
}
AjaxPlugin.$http.post('/api/v1/photos/wechat', userInfo, header)
.then((response) => {
app.flag = true
app.imgList = []
if (this.fdetail_version === '1.1') {
app.list = [...app.list, ...response.data]
this.parhList = [...this.list]
app.decrypt()
} else {
if (app.list.length === 0) {
response.data.forEach(item => {
this.list.push(item.origin.toString())
})
this.decrypt()
app.list = response.data
app.decrypt()
} else {
for (let i = 0; i < response.data.length; i++) {
app.list.push(response.data[i].origin)
}
app.decrypt()
}
}
if (app.list.length === 6) {
app.show = false
}
})
.catch(function (error) {
app.flag = true
if (error.response) {
app.$vux.loading.hide()
if (error.response.data.error_message) {
app.$vux.toast.show({
text: JSON.parse(error.response.data.error_message).zh_string,
type: 'cancel',
time: '1000'
})
} else {
app.$vux.toast.show({
text: '服务器错误，请稍后重试',
type: 'cancel',
time: '1000'
})
}
} else {
app.$vux.loading.hide()
app.$vux.toast.show({
text: '服务器错误，请稍后重试',
type: 'cancel',
time: '1000'
})
console.log('Error', error.message)
}
})
},
decrypt() {
let token = localStorage.getItem('token')
let opid = localStorage.getItem('userid')
var header = {
headers: {
token: token,
opid: opid
}
}
var that = this
let path;
path = this.fdetail_version === '1.1' ? this.list[this.index]['thumb'] : this.list[this.index];
AjaxPlugin.$http.get('api/v1/photos?path=' + path, header)
.then(res => {
that.imgList.push({msrc: 'data:image/jpeg;base64,' + res.data.value})
that.index++
this.$vux.loading.hide()
if (that.index < that.list.length) {
that.decrypt()
}
})
}
},
mounted() {
setTimeout(() => {
var timestamp = parseInt(new Date().getTime() / 1000)
var url
var u = navigator.userAgent
var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
var app = this
app.$http.get('static/config.json').then(response => {
var config = response.data
if (isiOS) {
url = config.host + global_.entryUrl
} else {
url = config.host + app.$route.path
}
var noncestr = Math.random().toString(36).substr(2)
app.$http.get('/api/v1/wechat/jsApiTicket?timestamp=' + timestamp + '&noncestr=' + noncestr + '&url=' + url)
.then(function (response) {
wx.config({
debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
appId: config.appId, // 必填，公众号的唯一标识
timestamp: timestamp, // 必填，生成签名的时间戳
nonceStr: noncestr, // 必填，生成签名的随机串
signature: response.data, // 必填，签名
jsApiList: ['chooseImage', 'previewImage', 'uploadImage', 'downloadImage', 'translateVoice', 'getLocalImgData', 'checkJsApi'] 
})
wx.error(function (res) {

})
})
.catch(function (error) {

if (error.response) {
console.log(error.response.data)
} else if (error.request) {
console.log(error.request)
} else {
console.log('Error', error.message)
}
})
}, response => {
console.log('数据加载失败')
})
}, 500)
},
async created() {
var that = this
let token = localStorage.getItem('token')
let opid = localStorage.getItem('userid')
var header = {
headers: {
token: token,
opid: opid
}
}
var data = localStorage.getItem('order')
var order = JSON.parse(data)
this.order = order
var arr = [], brr = []
if (order.fdetail.content.length > 0) {
this.num = 6 - order.fdetail.content[0].path.length
this.list = order.fdetail.content[0].path
if (this.list.length === 6) {
this.show = false
}
arr = order.fdetail.content[0].path
this.fdetail_version = order.fdetail.version
this.parhList = [...arr]
let path;
for (let item of arr) {
path = this.fdetail_version === '1.1' ? item['thumb'] : item;
await this.$http.get('api/v1/photos?path=' + path, header)
.then(res => {
brr.push({msrc: 'data:image/jpeg;base64,' + res.data.value})
})
}
this.imgList = brr
} else {
this.num = 6
}

this.$http.get('api/v1/accounts/' + opid, header)
.then(function (response) {
for (var i = 0; i < response.data.length; i++) {
if (response.data[i].type == 'INDV' || response.data[i].type == 'ENTP') {
that.role = response.data[i].type
}
}
})
.catch(function (error) {
if (error.response) {
if (error.response.data) {
that.$vux.alert.show({
title: '',
content: JSON.parse(error.response.data.error_message).zh_string,
})
}
}
})
console.log(order)
}

}



// WEBPACK FOOTER //
// ./src/components/addphoto.vue